"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectListConverter_1 = require("../../core/conversions/DataObjectListConverter"); //tslint:disable:max-classes-per-file


var SimulatedColumnStringConverter =
/*#__PURE__*/
function (_DataObjectListConver) {
  _inherits(SimulatedColumnStringConverter, _DataObjectListConver);

  function SimulatedColumnStringConverter() {
    _classCallCheck(this, SimulatedColumnStringConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatedColumnStringConverter).apply(this, arguments));
  }

  return SimulatedColumnStringConverter;
}(DataObjectListConverter_1.DataObjectListConverter);

exports.SimulatedColumnStringConverter = SimulatedColumnStringConverter;

var SimulatedColumnBigNumConverter =
/*#__PURE__*/
function (_DataObjectListConver2) {
  _inherits(SimulatedColumnBigNumConverter, _DataObjectListConver2);

  function SimulatedColumnBigNumConverter() {
    _classCallCheck(this, SimulatedColumnBigNumConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatedColumnBigNumConverter).apply(this, arguments));
  }

  return SimulatedColumnBigNumConverter;
}(DataObjectListConverter_1.DataObjectListConverter);

exports.SimulatedColumnBigNumConverter = SimulatedColumnBigNumConverter;